import { z } from "zod";

export const answerSubCategorySchema = z.object({
  id: z.number(),
  content: z.string(),
  is_answered: z.coerce.boolean(),
  question_count: z.number(),
  updated_at: z.coerce.date().nullish(),
});

export type AnswerSubCategory = z.infer<typeof answerSubCategorySchema>;
